import { buildStaticAssetUrl } from '../../../shared/config/assets';
import { env } from '../../../shared/config/env';
import type { SupportedLocale } from '../../../shared/i18n/locales';
import { buildPageHead, type PageHeadSpec } from './headSpec';

export { buildPageHead };

export function buildDefaultPageHead(locale: SupportedLocale): PageHeadSpec {
  return buildPageHead({
    locale,
    region: env.VITE_REGION,
    siteUrl: env.siteUrl,
    ogImageUrl: buildStaticAssetUrl('images', 'tcode-logo-green.png'),
  });
}
